var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSky({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99551 33.9967C2.65947 35.5218 1.33605 37.0469 0 38.5721C4.91564 42.5802 11.4698 43.6011 16.9527 39.9333C17.6963 39.4291 18.8433 38.2821 19.6878 36.8201L18.8433 41.3828H25.7504L27.3511 32.6859L31.8886 41.3828H46.9507L48.5766 32.5598H48.6144L59.517 18.6952H51.7403L46.5221 26.0057L42.8543 18.6952H35.8464L28.0948 28.5643L29.9224 18.6952H23.0153L22.6623 20.6236C18.2257 17.5734 10.7388 16.8802 6.3021 20.1699C2.42001 23.0563 1.94106 28.0223 5.60889 30.6818C7.02056 31.7028 9.80609 32.3708 11.8354 32.9127C15.0873 33.7824 13.3983 36.1016 11.432 36.4167C8.39441 36.9083 6.1256 35.5596 3.97028 33.9841L3.99551 33.9967ZM20.5952 31.9296C20.3936 31.1482 19.9777 30.3667 19.2844 29.6231C16.7762 26.9258 13.9024 27.3921 11.1925 26.3208C9.30191 25.5771 10.2472 23.8125 11.8228 23.5226C14.6083 22.9933 17.2299 23.9385 19.6878 25.5897L22.3976 22.1992L20.5952 31.9296ZM40.1192 41.0299L34.1574 30.581L38.7201 24.8713L41.8208 31.8036L40.1192 41.0299Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSky);
export default __webpack_public_path__ + "static/media/sky.618abe40edbebe3b1a9a58215ddaa090.svg";
export { ForwardRef as ReactComponent };